import * as api from 'requests'

export const getHomeStructure = () => dispatch => {
  api.GET_HOME_PAGE_STRUCTURE(({ MERGED, RAW }) => {
    const { foldLinks, categories } = JSON.parse(MERGED.VALUE)
    const { foldLinks: rawFoldLinks, categories: rawCategories } = JSON.parse(RAW.VALUE)
    
    dispatch(
      setHomeStructure({
        foldLinks,
        categories,
        appSettingId: MERGED.APP_SETTING_ID,
        rawStructure: { foldLinks: rawFoldLinks, categories: rawCategories }
      })
    )
  })
}

export const setHomeStructure = ({ foldLinks, categories, appSettingId, rawStructure }) => ({
  type: '@@h/SET_HOME_STRUCTURE',
  foldLinks,
  categories,
  appSettingId,
  rawStructure
})

export const updateAndPushCategories = categories => (dispatch, getState) => {
 
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.appSettingId,
    {
      NAME: 'HOME_PAGE_LINKS',
      VALUE: JSON.stringify({
        categories: categories,
        foldLinks: state.foldLinks
      }),
      CATEGORY: 'ADMIN',
      DESCR: ''
    },
    () => {
      dispatch(getHomeStructure())
    },
    e => {
      console.error(e)
    }
  )
}

export const updateCategories = categories => ({
  type: '@@h/UPDATE_CATEGORIES',
  categories
})

export const getSystemMessage = () => dispatch => {
  api.GET_APP_SETTING_BY_NAME('HOME_PAGE_MESSAGE', setting => {
    dispatch(
      populateSystemMessage({
        systemMessage: setting.VALUE,
        messageAppSettingId: setting.APP_SETTING_ID
      })
    )
  })
}

export const populateSystemMessage = ({ systemMessage, messageAppSettingId }) => ({
  type: '@@h/POPULATE_SYSTEM_MESSAGE',
  systemMessage,
  messageAppSettingId
})

export const updateAndPushSystemMessage = message => (dispatch, getState) => {
  dispatch(updateMessage(message))
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.messageAppSettingId,
    {
      NAME: 'HOME_PAGE_MESSAGE',
      VALUE: message,
      CATEGORY: 'ADMIN',
      DESCR: ''
    },
    () => {}
  )
}

export const updateMessage = message => ({
  type: '@@h/UPDATE_SYSTEM_MESSAGE',
  message
})

export const updateFoldLinks = foldLinks => ({
  type: '@@h/UPDATE_FOLD_LINKS',
  foldLinks
})

export const updateAndPushFoldLinks = foldLinks => (dispatch, getState) => {
  dispatch(updateFoldLinks(foldLinks))
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.appSettingId,
    {
      NAME: 'HOME_PAGE_LINKS',
      VALUE: JSON.stringify({
        categories: state.categories,
        foldLinks: foldLinks
      }),
      CATEGORY: 'ADMIN',
      DESCR: ''
    },
    () => {}
  )
}



// WEBPACK FOOTER //
// ./src/components/Home/HomeActions.js